import styles from './styles.css.js';
var marginBottomLevels = [0, 1, 2, 3, 4, 5, 6, 7, 8];

var getMarginBottomClass = function getMarginBottomClass(marginBottom, breakpoint) {
  return marginBottomLevels.indexOf(marginBottom) !== -1 ? styles["mb".concat(breakpoint ? breakpoint.charAt(0).toLowerCase() : '').concat(marginBottom)] : null;
};

export { getMarginBottomClass, marginBottomLevels };